import { render, staticRenderFns } from "./AccountSettingPreferences.vue?vue&type=template&id=0a767ace&scoped=true&"
import script from "./AccountSettingPreferences.vue?vue&type=script&lang=js&"
export * from "./AccountSettingPreferences.vue?vue&type=script&lang=js&"
import style0 from "./AccountSettingPreferences.vue?vue&type=style&index=0&id=0a767ace&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a767ace",
  null
  
)

export default component.exports